import React, { useState, useEffect } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  checkEmpty,
  getTabStatus,
  goToClientDashboard,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { numDifferentiation } from "../../CommonMethhods/CovertRupees";
import Loader from "../Common/Loader";
import { Constants } from "../../CommonMethhods/Constants";
import SmallLoader from "../Common/smallLoader";
import { Modal } from "react-bootstrap";
import LoaderForSearch from "../Common/LoaderForSearch";
import { toast } from "react-toastify";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function TopInActiveClientTable(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [inactiveClientInfo, setInActiveClientInfo] = useState([]);
  const [loader, setLoader] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [fileType, setFileType] = useState("grid");
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [serverError, setServerError] = useState("");
  const [count, setCount] = useState();

  const getInActiveClientTableInfo = async () => {
    if (fileType == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else if (fileType == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      pageSize: pageSize,
      pageNo: page,
      fileType: fileType,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getInActiveInFo = await axiosInstance.post(
        props.getInActiveClientInfo,
        `"${encPayload}"`,
      );
      let response = ApiResDecrypt(getInActiveInFo?.data);
      console.log(response, "stattaus");
      const res = response.data;
      setCount(res.totalClients);
      if (res) {
        // setInACtiveClientView(res.eq || res.clients);
        if (showModal == true) {
          if (fileType == "grid") {
            setInActiveClientInfo((prev) => {
              return [...prev, ...res.clients];
            });
          } else if (fileType == "pdf") {
            window.open(res, "_blank", "noopener,noreferrer");
          } else {
            window.open(res, "_blank", "noopener,noreferrer");
          }
        } else {
          setInActiveClientInfo(res.eq || res.clients);
        }
      }
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setScrollLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setScrollLoader(false);
      setServerError("Something went wrong, Please try again later.");
      if (fileType == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
    }
  };

  const handleScroll = (e) => {
    setFileType("grid");
    if (showModal == true) {
      setPageSize(5);
      const a = document.querySelector("#inactive1");
      if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
        if (count <= pageSize * page) {
          setScrollLoader(false);
          return;
        }
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    } else {
      setPage(1);
    }
  };

  const handleOnClick = () => {
    setShowModal(true);
    getInActiveClientTableInfo();
  };

  useEffect(() => {
    getInActiveClientTableInfo();
  }, [page, fileType]);

  const onHide = () => {
    setShowModal(false);
    setPage(1);
    setPageSize(5);
    setFileType("grid");
  };
  const handleFileType = (e) => {
    if (e.target.value) {
      setFileType(e.target.value);
      setPageSize(-1);
    }
  };
  

  const showInActiveData = (inactiveClientInfo) => {
    return (
      inactiveClientInfo &&
      inactiveClientInfo.map((info, key) => {
        return (
          <tr key={key}>
            <td>
              <a
                href="/client-dashboard"
                onClick={() => {
                  goToClientDashboard(info.clientCode, "");
                  getTabStatus("")
                }}
              >
                {checkEmpty(info.clientCode) === undefined || null
                  ? "-"
                  : info.clientCode}
              </a>
            </td>
            <td>
              {checkEmpty(info?.clientName) === undefined || null
                ? "-"
                : info?.clientName}
            </td>
            <td>
              {checkEmpty(info.ytdBrokerage) === undefined || null
                ? "-"
                : numDifferentiation(info.ytdBrokerage)}
            </td>
            {/* <td>
              {checkEmpty(info.margin) === undefined || null
                ? "-"
                : info.margin}
            </td> */}
            {/* <td>
              {checkEmpty(info.pastAvg) === undefined || null
                ? "-"
                : info.pastAvg}
            </td> */}
            {/* <td>
              <span
                className={
                  info.pnl == 0
                    ? "text-muted"
                    : info.pnl < 0
                    ? "red-txt"
                    : "green-txt"
                }
              >
                {checkEmpty(info.pnl) === undefined || null
                  ? "-"
                  : numDifferentiation(info.pnl)}
              </span>
            </td> */}
            <td>
              {checkEmpty(info.prevYrBrokerage) === undefined || null
                ? "-"
                : numDifferentiation(info.prevYrBrokerage)}
            </td>
            {/* <td>
              {checkEmpty(info.lifetimeBrokerage) === undefined || null
                ? "-"
                : numDifferentiation(info.lifetimeBrokerage)}
            </td> */}

          </tr>
        );
      })
    );
  };
  const showInActiveModelData = (inactiveClientInfo) => {
    return (
      inactiveClientInfo &&
      inactiveClientInfo.map((info, key) => {
        return (
          <tr key={key}>
            <td>
              <a
                href="/client-dashboard"
                onClick={() => {
                  goToClientDashboard(info.clientCode, "");
                  getTabStatus("")
                }}
              >
                {checkEmpty(info.clientCode) === undefined || null
                  ? "-"
                  : info.clientCode}
              </a>
            </td>
            <td>
              {checkEmpty(info?.clientName) === undefined || null
                ? "-"
                : info?.clientName}
            </td>
            <td>
              {checkEmpty(info.ytdBrokerage) === undefined || null
                ? "-"
                : numDifferentiation(info.ytdBrokerage)}
            </td>
            {/* <td>
              {checkEmpty(info.margin) === undefined || null
                ? "-"
                : info.margin}
            </td> */}
            {/* <td>
              {checkEmpty(info.pastAvg) === undefined || null
                ? "-"
                : info.pastAvg}
            </td> */}
            <td>
              <span
                className={
                  info.pnl == 0
                    ? "text-muted"
                    : info.pnl < 0
                    ? "red-txt"
                    : "green-txt"
                }
              >
                {checkEmpty(info.pnl) === undefined || null
                  ? "-"
                  : numDifferentiation(info.pnl)}
              </span>
            </td>
            <td>
              {checkEmpty(info.prevYrBrokerage) === undefined || null
                ? "-"
                : numDifferentiation(info.prevYrBrokerage)}
            </td>
            {/* <td>
              {checkEmpty(info.lifetimeBrokerage) === undefined || null
                ? "-"
                : numDifferentiation(info.lifetimeBrokerage)}
            </td> */}
          </tr>
        );
      })
    );
  };
  return (
    <div className="card-box inactiveclient">
      <div className="card-title">
        <div className="figure-inlac">
          <h2>{Constants.Top_Inactive_Clients}</h2>
          {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
        </div>

        {inactiveClientInfo && inactiveClientInfo.length > 0 ? (
          <div className="view-more-wrapper">
            <button className="view-more" onClick={handleOnClick}>
              {Constants.View_All}
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="scroll-table active-table">
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : inactiveClientInfo && inactiveClientInfo.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th>{Constants.Client_ID}</th>
                <th>Client Name</th>
                <th>{Constants.YTD_Brokerage}</th>
                {/* <th>{Constants.Margin_Txt}</th> */}
                {/* <th>{Constants.Past_Average}</th> */}
                {/* <th>{Constants.Overall_PnL}</th> */}
                <th>Previous Year Brokerage</th>
                {/* <th>{Constants.Lifetime_Income}</th> */}
              </tr>
            </thead>

            <tbody>{showInActiveData(inactiveClientInfo)}</tbody>
          </table>
        ) : serverError === "Something went wrong, Please try again later." ? (
          <h4 className="no-data">{serverError}</h4>
        ) : (
          noDataFound()
        )}
      </div>
      <Modal
        show={showModal}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              <h2 className="h2-css-all">{Constants.Top_Inactive_Clients}</h2>
              {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table inactive-modal-table align-section">
            <table className="table">
              <thead>
                <tr>
                  <th>{Constants.Client_ID}</th>
                  <th>Client Name</th>
                  <th>{Constants.YTD_Brokerage}</th>
                  {/* <th>{Constants.Margin_Txt}</th> */}
                  {/* <th>{Constants.Past_Average}</th> */}
                  <th>{Constants.Overall_PnL}</th>
                  <th>Previous Year Brokerage</th>
                  {/* <th>{Constants.Lifetime_Income}</th> */}
                </tr>
              </thead>

              <tbody id="inactive1" onScroll={handleScroll}>
                {showInActiveModelData(inactiveClientInfo)}
                {scrollLoader && (
                  <div className="loader-center">
                    <LoaderForSearch />
                  </div>
                )}
              </tbody>
            </table>
          </div>
          <div className="generate-btn-wrapper">
            <button
              className="generate-btn text-green"
              value="excel"
              onClick={handleFileType}
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {"Excel"}
                </>
              )}
            </button>
            <button
              className="generate-btn txt-purple"
              value="pdf"
              onClick={handleFileType}
            >
              {smallLoaderPdf ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-pdfsvg"></span> {"PDF"}
                </>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default TopInActiveClientTable;
